/* eslint-disable react-hooks/exhaustive-deps */
import { faCaretDown, faCaretRight, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API, defaultLimitPagination, get } from "../../../config";
import { MultiSelect } from "primereact/multiselect";
// import ContractorSelectWithTA from "../../common/ContractorSelectWithTA";
import {
  ExGSTClaculate,
  formatName,
  formatNumber,
  formatSubcontractorName,
} from "../../common/Misc";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import ExpandJournalEntry from "./ExpandJournalEntry";
import { debounce } from "lodash";
import CustomTooltip from "../../common/CustomTooltip";
import ProjectSubHeader from "../components/ProjectSubHeader";
import { useProject } from "../../common/ProjectContext";
import SearchBox from "../../common/SearchBox";

const JournalEntries = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const search = query.get("search");
  const [lastBatchId, setLastBatchId] = useState();
  const trustType = params?.trust_type;
  const trust_type = params?.trust_type === "project" ? 1 : 0;

  const projectId = params?.project_id;

  const [projectLoading, setLoading] = useState(false);
  const [journalEntryList, setJournalEntryList] = useState(null);
  const [journalEntryData, setJournalEntryData] = useState(null);
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState("transaction_date");
  const [sortOrder, setSortOrder] = useState("DESC");

  const [selectedContacts, setSelectedContacts] = useState(null);
  const [selectedMainContacts, setSelectedMainContacts] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [contactListLoading, setContactListLoading] = useState(false);
  const [contactOptions, setContactOptions] = useState([]);
  const [contactCurrentPage, setContactCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  const [selectedContracts, setSelectedContracts] = useState(null);
  const [selectedMainContracts, setSelectedMainContracts] = useState([]);

  const [expandedRow, setExpandedRow] = useState([]);

  // const [contractorDetails, setContractorDetails] = useState([]);

  const [show, setShow] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const { ProjectReadOnly } = useProject();

  const handleContactList = useCallback(
    async (page) => {
      if (page !== 1 && (contactListLoading || !hasMoreData)) return;
      if (page === 1) {
        setContactOptions([]);
      }
      try {
        setContactListLoading(true);
        const response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=${page}`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          // setContactOptions(list);
          let contactItemList = list ? list : [];
          setContactOptions((prev) => [...prev, ...contactItemList]);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    [projectId]
  );

  useEffect(() => {
    handleContactList(1);
  }, [handleContactList]);

  const contactLoadMoreData = useCallback(
    (event) => {
      const { last } = event;

      // Trigger API call if scrolled near the end of the loaded data
      if (!contactListLoading && hasMoreData && last >= contactOptions.length) {
        handleContactList(contactCurrentPage + 1);
      }
    },
    [contactListLoading, hasMoreData, contactOptions.length]
  );

  const fetchContactSearchData = async (query) => {
    if (query) {
      try {
        setContactListLoading(true);
        const response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&search=${
            query ? query : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=1`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          setContactOptions(list);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  // Debounced function for filtering
  const debouncedFetchData = useMemo(
    () => debounce(fetchContactSearchData, 300),
    []
  );

  // Handle filtering
  const handleContactSearch = (event) => {
    const query = event.filter;
    debouncedFetchData(query); // Call debounced function
  };

  // Clean up the debounced function on unmount
  useMemo(() => () => debouncedFetchData.cancel(), [debouncedFetchData]);

  const handleContactFilter = async (e) => {
    if (e?.filter) {
      if (contactOptions?.length > 0 && contactOptions?.find((item) => item?.label?.includes(e?.filter))) {
      } else {
        await handleContactSearch(e);
      }
    } else {
      await handleContactList(1);
    }
  };

  const fetchJournalEntries = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.JOURNAL_ENTRIES}?builder_project_id=${projectId}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&contacts=${
            selectedMainContacts ? selectedMainContacts : ""
          }&contracts=${
            selectedMainContracts ? selectedMainContracts : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_type=${trust_type}`
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const journalEntryList = data.data.data;
        let expanded = [];
        for (let i = 0; i < journalEntryList?.length; i++) {
          expanded.push(journalEntryList[i]?.id);
        }
        setExpandedRow(expanded);
        setJournalEntryList(journalEntryList);
        setLastBatchId(data?.last_batch_id + 1);
        return data.data;
      } catch (error) {
        setLoading(false);
        setJournalEntryList([]);

        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    [
      projectId,
      sortField,
      sortOrder,
      trust_type,
      selectedMainContacts,
      searchParam,
    ]
  );

  useEffect(() => {
    navigate(
      `?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  const toggleShowModal = (data) => {
    setShow(true);
    setDetailsData(data);
  };

  const toggleCloseModal = () => {
    setShow(false);
  };

  const journalEntryGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: journalEntryList[i]?.id,
        transaction_date: journalEntryList[i]?.transaction_date
          ? journalEntryList[i]?.transaction_date
          : "",
        approved_date: journalEntryList[i]?.approved_date
          ? journalEntryList[i]?.approved_date
          : "-",
        period: journalEntryList[i]?.period ? journalEntryList[i]?.period : "-",
        batch_id: journalEntryList[i]?.batch_id
          ? journalEntryList[i]?.batch_id
          : "-",
        reference_number: journalEntryList[i]?.reference_number
          ? journalEntryList[i]?.reference_number
          : "-",
        // source: String(
        //   journalEntryList[i]?.journal_entry_details[0]
        //     ?.transaction_reference_number
        // ).includes("(R)")
        //   ? "Receipt"
        //   : String(
        //       journalEntryList[i]?.journal_entry_details[0]
        //         ?.transaction_reference_number
        //     ).includes("(P)")
        //   ? "Payments"
        //   : String(
        //       journalEntryList[i]?.journal_entry_details[0]
        //         ?.transaction_reference_number
        //     ).includes("(PS)")
        //   ? "Payment Schedule"
        //   : String(
        //       journalEntryList[i]?.journal_entry_details[0]
        //         ?.transaction_reference_number
        //     ).includes("(JE)")
        //   ? "Journal Entries"
        //   : "-",
        source: journalEntryList[i]?.receipt_id
          ? "Receipt"
          : String(
              journalEntryList[i]?.journal_entry_details[0]
                ?.transaction_reference_number
            ).includes("(PS)")
          ? "Payment Schedule"
          : journalEntryList[i]?.payment_id
          ? "Payments"
          : String(
              journalEntryList[i]?.journal_entry_details[0]
                ?.transaction_reference_number
            ).includes("(JE)")
          ? "Journal Entries"
          : "-",
        amount: journalEntryList[i]?.total_amount
          ? `$${formatNumber(journalEntryList[i]?.total_amount)}`
          : "-",
        gst_amount: journalEntryList[i]?.gst_amount
          ? `$${formatNumber(journalEntryList[i]?.gst_amount)}`
          : "-",
        net_amount: journalEntryList[i]?.net_amount
          ? `$${formatNumber(journalEntryList[i]?.net_amount)}`
          : "-",
        journal_entry_details: journalEntryList[i]?.journal_entry_details,
        action: (
          <>
            <CustomTooltip message={"View"}>
              <span>
                <FontAwesomeIcon
                  onClick={() => {
                    toggleShowModal(journalEntryList[i]);
                    // fetchJournalEntryData(journalEntryList[i].id);
                    setJournalEntryData(
                      journalEntryList[i]?.journal_entry_details
                    );
                  }}
                  icon={faEye}
                  size="1x"
                  data-toggle="modal"
                  data-target="#businessDetail"
                />
              </span>
            </CustomTooltip>
            {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <Link to={`/projects/${projectId}/journal-entries/edit?id=${journalEntryList[i].id}`}>
              <FontAwesomeIcon icon={faEdit} size="1x" />
            </Link> */}
          </>
        ),
      });
    }
    return items;
  };
  const journalEntries = journalEntryGenerator(journalEntryList?.length);

  useEffect(() => {
    fetchJournalEntries();
  }, [fetchJournalEntries]);

  // useEffect(() => {
  //   fetchJournalEntryData();
  // }, [fetchJournalEntryData]);

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchJournalEntries(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchJournalEntries(limit, page);
  };

  const columns = [
    {
      dataField: "transaction_date",
      text: "Transaction Date",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "approved_date",
      text: "Approval Date",
      sort: true,
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    // {
    //   dataField: 'period',
    //   text: 'Period',
    //   sort: true,
    //   headerStyle: () => {
    //     return { width: '8%' };
    //   }
    // },
    {
      dataField: "batch_id",
      text: "Batch Id ",
      sort: true,
      headerStyle: () => {
        return { width: "17%" };
      },
    },
    {
      dataField: "reference_number",
      text: "Reference/ID",
      sort: true,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "source",
      text: "Source",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "amount",
      text: "Total Amount",
      headerStyle: () => {
        return { width: "22%" };
      },
    },

    // {
    //   dataField: 'gst_amount',
    //   text: 'GST Amount',
    //   headerStyle: () => {
    //     return { width: '15%' };
    //   }
    // },
    // {
    //   dataField: 'net_amount',
    //   text: 'Net Amount',
    //   headerStyle: () => {
    //     return { width: '15%' };
    //   }
    // },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerStyle: {
        textAlign: "center",
      },
      // style: { width: '8%' }
    },
  ];

  // const handleContractorSelect = (contractor) => {
  //   setContractorDetails(contractor);
  // };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandJournalEntry
          id={row?.key}
          projectId={projectId}
          expandJournalData={row?.journal_entry_details}
        />
      </>
    ),
    expanded: expandedRow,
    onlyOneExpanding: false,
    showExpandColumn: true,
    expandByColumnOnly: true,
    nonExpandable: [
      "Revenues",
      "totalRevenue",
      "Expenses",
      "totalExpense",
      "totalData",
      "blank-row",
    ],
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return (
          <b>
            <FontAwesomeIcon icon={faCaretDown} />
          </b>
        );
      }
      return (
        <b>
          <FontAwesomeIcon icon={faCaretRight} />
        </b>
      );
    },
    expandColumnRenderer: ({ expanded, rowKey }) => {
      if (expanded) {
        return (
          <b>
            <FontAwesomeIcon icon={faCaretDown} />
          </b>
        );
      }
      if (
        rowKey === "Revenues" ||
        rowKey === "totalRevenue" ||
        rowKey === "Expenses" ||
        rowKey === "totalExpense" ||
        rowKey === "totalData" ||
        rowKey === "blank-row"
      ) {
        return <div className="not-expaned-cell-pl-report" />;
      }
      return (
        <b>
          <FontAwesomeIcon icon={faCaretRight} />
        </b>
      );
    },
  };

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  const viewJournalDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: journalEntryData[i]?.id,
        transaction_date: detailsData?.transaction_date
          ? detailsData?.transaction_date
          : "",
        account: journalEntryData[i]?.chart_of_account
          ? (journalEntryData[i]?.chart_of_account?.code?.length < 4
              ? padWithLeadingZeros(
                  Number(journalEntryData[i]?.chart_of_account?.code),
                  4
                )
              : journalEntryData[i]?.chart_of_account?.code.toString()) +
            (journalEntryData[i]?.chart_of_account?.sub_code
              ? "." + journalEntryData[i]?.chart_of_account?.sub_code.toString()
              : "") +
            " - " +
            journalEntryData[i]?.chart_of_account?.name
          : "",
        // contact: journalEntryData[i]?.contact
        //   ? formatName(
        //       journalEntryData[i]?.contact?.first_name,
        //       journalEntryData[i]?.contact?.last_name
        //     ) +
        //     `${
        //       journalEntryData[i]?.contact?.is_pta === 0
        //         ? "(RTA)"
        //         : journalEntryData[i]?.contact?.is_pta === 1
        //         ? "(PTA)"
        //         : journalEntryData[i]?.contact?.is_pta === 2
        //         ? "(Withdrawal)"
        //         : journalEntryData[i]?.contact?.is_pta === 3
        //         ? "(Principal)"
        //         : journalEntryData[i]?.contact?.is_pta === 4
        //         ? "(Trustee)"
        //         : ""
        //     }`
        //   : "-",
        contact: journalEntryData[i]?.contact
          ? formatSubcontractorName(journalEntryData[i]?.contact) +
            `${
              journalEntryData[i]?.contact?.is_pta === 0
                ? " - RTA"
                : journalEntryData[i]?.contact?.is_pta === 1
                ? " - PTA"
                : journalEntryData[i]?.contact?.is_pta === 2
                ? " - Withdrawal/General Business"
                : journalEntryData[i]?.contact?.is_pta === 3
                ? " - Principal"
                : journalEntryData[i]?.contact?.is_pta === 4
                ? " - Trustee"
                : ""
            }`
          : "-",
        debit:
          journalEntryData[i]?.transaction_type === 0
            ? journalEntryData[i]?.amount
              ? "$" + formatNumber(Number(journalEntryData[i]?.amount))
              : "$0.00"
            : "-",
        credit:
          journalEntryData[i]?.transaction_type === 1
            ? journalEntryData[i]?.amount
              ? "$" + formatNumber(Number(journalEntryData[i]?.amount))
              : "$0.00"
            : "-",
        gst:
          journalEntryData[i]?.gst === 0
            ? "GST Excluded"
            : journalEntryData[i]?.gst === 1
            ? "GST 10%"
            : journalEntryData[i]?.gst === 2
            ? "BAS Excluded"
            : "GST on Imports",
        tax: journalEntryData[i]?.gst_amount
          ? "$" + formatNumber(Number(journalEntryData[i]?.gst_amount))
          : "-",
        ex_gst_amount: journalEntryData[i]?.amount
          ? "$" +
            ExGSTClaculate(
              journalEntryData[i]?.amount,
              journalEntryData[i]?.gst
            )
          : 0,
        description: journalEntryData[i]?.description
          ? journalEntryData[i]?.description
          : "-",
      });
    }
    return items;
  };
  const viewJournalData = viewJournalDataGenerator(journalEntryData?.length);

  const viewColumns = [
    // {
    //   dataField: 'transaction_date',
    //   text: 'Transaction Date',
    //   headerStyle: () => {
    //     return { width: '15%' };
    //   },
    // },
    {
      dataField: "contact",
      text: "Contact ",
      style: { width: "18%" },
    },
    {
      dataField: "account",
      text: "Account",
      style: { width: "24%" },
    },
    // {
    //   dataField: 'gst',
    //   text: 'GST',
    //   style: { width: '10%' }
    // },
    {
      dataField: "debit",
      text: "Debit",
      style: { width: "15%" },
    },
    {
      dataField: "credit",
      text: "Credit",
      style: { width: "15%" },
    },
    // {
    //   dataField: 'tax',
    //   text: 'Tax',
    //   style: { width: '11%' }
    // },
    // {
    //   dataField: 'ex_gst_amount',
    //   text: 'Ex. GST Amount',
    //   style: { width: '11%' }
    // },
    {
      dataField: "description",
      text: "Description",
    },
  ];

  const filterContactInputRef = useRef();
  const filterContractInputRef = useRef();

  const handleContactChange = (e) => {
    setSelectedContacts(e.value);
  };

  const handleApplyFilter = () => {
    setPage(1);
    setSelectedMainContacts(selectedContacts);
    filterContactInputRef.current.hide();
  };

  const myContactResetFunction = () => {
    setSelectedContacts([]);
    setPage(1);
    setSelectedMainContacts([]);
    filterContactInputRef && filterContactInputRef.current.focus();
  };

  // eslint-disable-next-line no-unused-vars
  const handleContractChange = (e) => {
    setSelectedContracts(e.value);
  };

  // eslint-disable-next-line no-unused-vars
  const handleContractApplyFilter = () => {
    setPage(1);
    setSelectedMainContracts(selectedContracts);
    filterContractInputRef.current.hide();
  };

  // eslint-disable-next-line no-unused-vars
  const myContractResetFunction = () => {
    setSelectedContracts([]);
    setPage(1);
    setSelectedMainContracts([]);
    filterContractInputRef && filterContractInputRef.current.focus();
  };

  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      <div className="cms-page journal-entry-page">
        <div className="page-content-block">
          <div className="full-content-block">
            <ProjectSubHeader
              title={`Journal Entries For ${trust_type === 0 ? "RTA" : "PTA"}`}
            />
            <div className="content-details">
              <div className="table-top-btn">
                {/* <div className="search-section">
                  <ContractorSelectWithTA
                    regionName={"0"}
                    projectId={projectId}
                    value={contractorDetails ? contractorDetails : null}
                    onChange={(contractor) => {
                      handleContractorSelect(contractor);
                    }}
                    className="contactname-select"
                    placeholder="Select Subcontractor"
                    isClearable={true}
                    isMulti={true}
                  />
                </div> */}
                <SearchBox
                  className={"journal-entry-search-box"}
                  placeholder={"Search Journal Entries"}
                  searchParamData={searchParamData}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                />
                <div className="contractor-select-filter sub-contract-filter">
                  <MultiSelect
                    value={selectedContacts}
                    onChange={(e) => {
                      handleContactChange(e);
                    }}
                    options={
                      contactOptions?.length > 0
                        ? contactOptions?.filter(
                            (option, index, self) =>
                              index ===
                              self.findIndex((o) => o.value === option.value)
                          )
                        : []
                    }
                    showSelectAll={false}
                    optionLabel="label"
                    filter
                    placeholder="Select Subcontractor(s)"
                    maxSelectedLabels={0}
                    selectedItemsLabel={`${selectedContacts?.length} Subcontractor(s) Selected`}
                    onHide={() => {
                      setSelectedMainContacts(selectedContacts);
                      setPage(1);
                    }}
                    style={{
                      fontSize: "13px",
                      minWidth: "320px",
                    }}
                    loading={contactListLoading}
                    onFilter={(e) => handleContactFilter(e)}
                    virtualScrollerOptions={{
                      lazy: true, // Enables lazy loading
                      onLazyLoad: contactLoadMoreData, // Triggered on scroll
                      itemSize: 40, // Height of each item
                    }}
                    ref={filterContactInputRef}
                    panelFooterTemplate={
                      <>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            handleApplyFilter();
                          }}
                        >
                          Apply
                        </Button>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            myContactResetFunction();
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    }
                  />

                  {/* <MultiSelect
                    value={selectedContracts}
                    onChange={(e) => {
                      handleContractChange(e);
                    }}
                    options={contractOptions}
                    optionLabel="label"
                    filter
                    placeholder="Select Contract"
                    maxSelectedLabels={0}
                    selectedItemsLabel={`${selectedContracts?.length} Contract(s) Selected`}
                    onHide={() => {
                      setSelectedMainContracts(selectedContracts);
                      setPage(1);
                    }}
                    style={{
                      fontSize: "13px",
                      maxWidth: "350px",
                    }}
                    ref={filterContractInputRef}
                    panelFooterTemplate={
                      <>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            handleContractApplyFilter();
                          }}
                        >
                          Apply
                        </Button>
                        <Button
                          className="multiSelect-button"
                          onClick={() => {
                            myContractResetFunction();
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    }
                  /> */}
                </div>
                {!ProjectReadOnly && (
                  <div className="table-btn">
                    <Button
                      variant="primary"
                      onClick={() => {
                        navigate(
                          `/projects/${projectId}/${trustType}/journal-entries/add`,
                          {
                            state: { lastBatchId: lastBatchId },
                          }
                        );
                      }}
                    >
                      Add New
                    </Button>
                  </div>
                )}
              </div>
              <div className="custom-table journal-main-table">
                {projectLoading && <Spin />}

                <BootstrapTable
                  keyField="key"
                  remote
                  data={journalEntries || []}
                  columns={columns}
                  expandRow={expandRow}
                  onTableChange={handleTableChange}
                  noDataIndication="No Data Found"
                />

                <Pagination
                  total={total}
                  limit={parseInt(limit)}
                  currentPage={page}
                  updateLimit={handleUpdateLimit}
                  updatePage={handleChangePage}
                  from={from}
                  to={to}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {show && (
        <Modal
          size="lg"
          show={show}
          onHide={toggleCloseModal}
          dialogClassName="larg-popup journal-modal review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header closeButton>Journal Entry Details</Modal.Header>
          <Modal.Body style={{ padding: "15px 15px 15px 15px" }}>
            <>
              <div>
                <BootstrapTable
                  keyField="key"
                  data={viewJournalData}
                  columns={viewColumns}
                  noDataIndication="No Data Found"
                />
              </div>
            </>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default JournalEntries;
